import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "vehicles-map-shell" }
const _hoisted_2 = {
  key: 0,
  class: "route-planner-panel"
}
const _hoisted_3 = { class: "route-planner-panel__row" }
const _hoisted_4 = { class: "route-planner-panel__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      id: "map",
      class: "vehicles-map"
    }, null, -1)),
    (_ctx.routePlanner.active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.routePlanner.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fa fa-circle-notch fa-spin" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.map.routePlanning.loading')), 1)
              ], 64))
            : (_ctx.routePlanner.summary)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-arrows-expand-vertical" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('components.map.routePlanning.distance')) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.routePlanner.summary.distance) + " km", 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-clock" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('components.map.routePlanning.duration')) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatRouteDuration(_ctx.routePlanner.summary.duration)), 1)
                  ]),
                  _createElementVNode("button", {
                    class: "route-planner-panel__clear",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearRoutePlan && _ctx.clearRoutePlan(...args)))
                  }, _toDisplayString(_ctx.$t('components.map.routePlanning.clear')), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_ctx.selectedVehicleImei
          ? _ctx.$t('components.map.routePlanning.clickDestination')
          : _ctx.$t('components.map.routePlanning.selectVehicle')), 1)
                ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}